export type TAnalyticsEvent = {
  name: EAnalyticsEventName
  properties?: Record<string, unknown>
}

export interface IAnalyticsAdapter {
  trackEvent: (event: TAnalyticsEvent) => void
}
//TODO separate for each app
export enum EAnalyticsEventName {
  Register = 'signup',
  Login = 'login',
  BuyToken = 'buy_token',
  SellToken = 'sell_token',
  WalletCharge = 'wallet_charge',
}
